<div
  class="hover-tooltip-cell"
  [matTooltip]="tooltipMessage()"
  [matTooltipDisabled]="tooltipDisabled()"
  [matTooltipClass]="tooltipClass()"
  [matTooltipPosition]="tooltipPosition()"
  [matTooltipShowDelay]="tooltipShowDelay()"
  [matTooltipHideDelay]="tooltipHideDelay()"
>
  <span class="hover-tooltip-cell__value">
    {{ displayValue() }}
  </span>

  @if (detailViewerConfig() && showEyeIcon()) {
  <button
    type="button"
    class="detail-viewer-cell__eye"
    (click)="openDetails($event)"
  >
    <lib-icon-button
      activeImgSrc="images/eye.svg"
      inactiveImgSrc="images/eye.svg"
      altText="View"
    >
    </lib-icon-button>
  </button>
  }
</div>
